import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sailings" }

import { startOfToday } from "date-fns";
import { computed, ref } from "vue";
import useDeparturesQuery from "../composables/useDeparturesQuery";
import SailingsDates from "./SailingsDates.vue";
import SailingsTable from "./SailingsTable.vue";

interface Props {
    selectedRoute: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SailingUpdates',
  props: {
    selectedRoute: {}
  },
  setup(__props: any) {

const props = __props;

const date = ref(startOfToday());
const route = computed(() => props.selectedRoute);

const { data, isLoading, isRefetching } = useDeparturesQuery(route, date);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("header", { class: "sailings__header" }, [
      _createElementVNode("h1", { class: "h3" }, "All sailings are shown in local time")
    ], -1)),
    _createVNode(SailingsDates, {
      modelValue: date.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(SailingsTable, {
      departures: _unref(data),
      isLoading: _unref(isLoading) ||_unref(isRefetching)
    }, null, 8, ["departures", "isLoading"])
  ]))
}
}

})